import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Property } from '../property'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { PropertyDetailComponent } from '../property-detail/property-detail.component'

@Component({
  selector: 'app-property-detail-side',
  templateUrl: './property-detail-side.component.html',
  styleUrls: ['./property-detail-side.component.scss'],
  imports: [PropertyDetailComponent],
})
export class PropertyDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public property: Property
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.property = route.snapshot.data['property']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
